import { cn } from "@/lib/utils";
import { useDraggable } from "@dnd-kit/core";

type Props = {
  children: React.ReactNode;
  id: string;
  left: string;
  top: string;
  height: number;
  width: number;
  /**
   * Lifts this card above its neighbours. Every card carries a transform, so
   * each is its own stacking context and nothing inside one can paint over the
   * next: with all of them on the same z-index, the later sibling always wins
   * and its neighbour's controls end up unclickable underneath it. Raising the
   * card is the only way to raise what it contains.
   */
  elevated?: boolean;
};

function Draggable(props: Props) {
  const { attributes, listeners, setNodeRef, transform, isDragging } =
    useDraggable({
      id: props.id,
      data: {
        id: props.id,
        left: props.left,
        top: props.top,
        height: props.height,
        width: props.width,
      },
    });

  return (
    <div
      ref={setNodeRef}
      className={cn(
        "absolute hover:z-30 text-center touch-none",
        props.elevated ? "z-30" : "z-1",
        isDragging && "opacity-50",
      )}
      style={{
        transform:
          transform && !isDragging
            ? `translate3d(${transform.x - props.width / 2}px, ${
                transform.y - props.height / 2
              }px, 0)`
            : `translate(-50%, -50%)`,
        left: props.left,
        top: props.top,
      }}
      {...listeners}
      {...attributes}
    >
      {props.children}
    </div>
  );
}

export default Draggable;
